import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "toastContainer",
  class: "toast-container position-fixed bottom-0 end-0 p-3"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "liveToast",
    class: "toast hide text-bg-success align-items-center border-0",
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "toast-body fs-md-15 fs-lg-16" }, " Success! "),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn-close shadow-none btn-close-white me-2 m-auto",
        "data-bs-dismiss": "toast",
        "aria-label": "Close"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_MainSidebarTemplate = _resolveComponent("MainSidebarTemplate")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.$route.meta.requiresNoSidebar)
      ? (_openBlock(), _createBlock(_component_MainHeader, {
          key: 0,
          onWarehouseScopeUpdated: _ctx.warehouseScopeUpdated
        }, null, 8, ["onWarehouseScopeUpdated"]))
      : _createCommentVNode("", true),
    (!_ctx.$route.meta.requiresNoSidebar && !_ctx.$route.meta.template)
      ? (_openBlock(), _createBlock(_component_MainSidebar, { key: 1 }))
      : _createCommentVNode("", true),
    (!_ctx.$route.meta.requiresNoSidebar && _ctx.$route.meta.template)
      ? (_openBlock(), _createBlock(_component_MainSidebarTemplate, { key: 2 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_component_router_view, { key: _ctx.warehouseId }, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })),
      _createVNode(_component_MainFooter)
    ]),
    _hoisted_2
  ], 64))
}